import { render } from "./CoolpadPCUI.vue?vue&type=template&id=1750989e"
import script from "./CoolpadPCUI.vue?vue&type=script&lang=js"
export * from "./CoolpadPCUI.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__